import React, { useEffect, useMemo } from "react"
import { Link, NavLink, useLocation, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import Logo from "../icons/logo"
import classes from './Header.module.css'
import HeaderSearchBox from "./search/HeaderSearchBox"
import { retrieveAllWorkQs, retrieveAllWorkQsGrouped } from "../lib/systemData"
import { workqueueActions } from "../store/workqueue"
import { useUserTabEditPermissionDisabled } from "../lib/usersPermissions"
import RecentCases from "./RecentCases"
import QueuesMenuGrouped from "./QueuesMenuGrouped"
import { allFrontendCustomWorkQSlugs } from "../components/work_queues/pages/custom/globalWorkQStructure"
import Logout from "./Logout"

const Header = () => {
    let historyPermission = useUserTabEditPermissionDisabled('history_view')
    let transfersPermission = useUserTabEditPermissionDisabled('practice_view_transfer')
    const location = useLocation()
    const dispatch = useDispatch()
    let { workqSlug } = useParams();
    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);

    useEffect(() => {
        const workqLists = retrieveAllWorkQs()
        if (!workqLists) {
            return
        }

        let slugFromRoute = workqSlug
        if (!slugFromRoute) {
            for (const slug of allFrontendCustomWorkQSlugs) {
                if (location.pathname.startsWith(`/work-queues/${slug}`)) {
                    slugFromRoute = slug
                    break
                }
            }
        }
        if (!slugFromRoute) {
            const match = location.pathname.match(/^\/work-queues\/([^/]+)/)
            slugFromRoute = match?.[1]
        }

        if (slugFromRoute) {
            const found = workqLists.find((item) => item.slug === slugFromRoute)
            if (found && selectedWorkQueue?.slug !== slugFromRoute) {
                dispatch(workqueueActions.setSelectedWorkQueue(found))
            }
        }
    }, [dispatch, location.pathname, selectedWorkQueue?.slug, workqSlug])

    const allWorkQGrouped = useMemo(() => {
        return retrieveAllWorkQsGrouped()
    }, [])

    return <header className={classes.header}>
        <div className={classes.header_inner}>
            <div className={classes.logo_container}>
                <Link to='/dashboard'>
                    <Logo />
                    <span className="sr-only">home link</span>
                </Link>
            </div>
            <div className={classes.navigation_container}>       
                <HeaderSearchBox />
                <nav>
                    <ul className={classes.main_navigation}>
                        <li>
                            <NavLink to='/dashboard' className={({ isActive }) => isActive ? classes.link_active : "" }><i className="ti ti-layout-2"></i>Dashboard</NavLink>
                        </li>
                        
                        {/* <QueuesMenu classes={classes} goToWorkQ={goToWorkQ} workqSlug={workqSlug} allWorkQ={allWorkQ}/> */}

                        <QueuesMenuGrouped classes={classes} workqSlug={workqSlug} allWorkQGrouped={allWorkQGrouped} />

                        <RecentCases classes={classes} />

                        {/* <li>
                            <span className="link_disabled"><i className="ti ti-calendar"></i>Calendar</span>
                        </li> */}
                        <li>
                            <NavLink to='/tasks' className={({ isActive }) => isActive ? classes.link_active : "" }><i className="ti ti-bolt"></i>Tasks</NavLink>
                        </li>
                        {/* <li>
                            <span className="link_disabled"><img src={procodocsLogo} alt="procodocs" /></span>
                        </li> */}
                        <li>
                            <span className="link_disabled"><i className="ti ti-file-description"></i>Documents</span>
                        </li>
                        {transfersPermission && <li>
                            <NavLink to='/transfers' className={({ isActive }) => isActive ? classes.link_active : "" }><i className="ti ti-home-move"></i>Transfers</NavLink>
                        </li>}
                        {/* <li>
                            <NavLink to='/referrals' className={({ isActive }) => isActive ? classes.link_active : "" }><i className="ti ti-user-plus"></i>Referrals</NavLink>
                        </li> */}
                        {historyPermission && <li>
                            <NavLink to='/history' className={({ isActive }) => isActive ? classes.link_active : "" }><i className="ti ti-history"></i>History</NavLink>
                        </li>}

                        <li>
                            <NavLink to='/exports' className={({ isActive }) => isActive ? classes.link_active : "" }><i className="ti ti-report"></i>Exports</NavLink>
                        </li>

                        <li className={classes.logout}>
                            {/* <Button to='/' className={classes.logout} click={logoutHandler} btnStyle={'btn_simple'} title={'logout'} bypassisCaseArchived={true}>
                                <i className="ti ti-logout"></i>
                            </Button> */}
                            <Logout />
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </header>
}

export default Header